import { gql } from "@apollo/client";

export const CREATE_SHIPPING_LABEL_MUTATION = gql`
  mutation CreateShippingLabel(
    $contact_id: Int
    $name: String
    $address1: String
    $address2: String
    $city: String
    $state: String
    $zip: String
  ) {
    createShippingLabel(
      contact_id: $contact_id
      name: $name
      address1: $address1
      address2: $address2
      city: $city
      state: $state
      zip: $zip
    ) {
      _id
      tracking_number
      status
      label_url
      contact_id
      customer_id
      account
      created_at
      updated_at
    }
  }
`;
